import Vue from 'vue'
import Vuex from 'vuex'
import 'babel-polyfill'
import getters from './getters'
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
Vue.use(Vuex)
const websockIp = process.env.MESSAGE_IP
const state = {
  websockIp: websockIp
}
const store = new Vuex.Store({
  state,
  modules,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js